export function isSelfServiceWorkspacePath(pathname: string): boolean {
    if (pathname === '/dashboard' || pathname === '/billing' || pathname === '/venues' || pathname === '/venues/new') return true
    if (pathname === '/venues/start') return false

    return /^\/venues\/[^/]+/.test(pathname)
}
